import { createAction } from '@reduxjs/toolkit';
import { IDefaultSwapTokenInfo } from './typings'

export const setVoteList = createAction<any>('vote/setVoteList');
export const setVoteInfo = createAction<Record<string,any>>('vote/setVoteInfo');
export const setVoteAmount = createAction<string|number>('vote/setVoteAmount');
export const setMyVoteInfo = createAction<Record<string,any>>('vote/setMyVoteInfo');
export const setMyVoteList = createAction<any[]>('vote/setMyVoteList');
export const setRefundVoteList = createAction<any[]>('vote/setRefundVoteList');

export const setFilter = createAction<any>('vote/setFilter');
export const setSwapCount = createAction<any>('vote/setSwapCount');
export const setDefaultSwapTokenInfo = createAction<IDefaultSwapTokenInfo>('vote/setDefaultSwapTokenInfo');
